export const APPOINTMENT_FORM = 1
export const DEPOSIT_PAID = 2
export const PAYMENT_COMPLETED = 3

export const TYPE_STATUS = {
  [APPOINTMENT_FORM]: '预约单',
  [DEPOSIT_PAID]: '已付定金',
  [PAYMENT_COMPLETED]: '已结清'
}

export const NO_ORDER_TAKING = 5
